import React, { Component } from 'react'
import Select from 'react-select'
import apiService from '../../services/ApiService'

class Kitchens extends Component {
    constructor() {
        super()
        this.state = {
            kitchensList: {},
            selectedCity:{},
            comboType:""
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
          let comboType=this.props.comboType 
             this.setState({
                 comboType: comboType
             },() => {
                 this.getKitchensList()
            });  
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

     componentDidUpdate() {

       

        if (this.props.selectedCity!== this.state.selectedCity) {
             let selectedCity=this.props.selectedCity 
             this.setState({
                selectedCity:selectedCity
                },() => {
                 this.getKitchensList()
            });            
        }
    }

    getKitchensList = () => {
        apiService.getKitchensDetailList(this.state.selectedCity,this.state.comboType)
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        kitchensList: listData.data
                    })                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }
    

    render() {
        let list = {}
        list = Object.keys(this.state.kitchensList).map((value,index) => {
            
            return {
                label : this.state.kitchensList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Kitchen"
                options={list}
                onChange={(e) => { (e) ? this.props.kitchenChange(e) : this.props.kitchenChange([])}}
                />
            </div>
        )
    }
}
export default Kitchens


// WEBPACK FOOTER //
// ./src/common/DropDowns/Kitchens.js